import { NavigateFunction } from "react-router"
import { RoleType, StorageKey } from "../../../App/enums"
import SessionService from "../../../App/SessionService"

/**
 * Navigate to dashboard or scroll to top if already on dashboard
 * Native app behavior: Tapping header/logo scrolls to top when on same screen
 */
export const onDashboardNavigation = (
    role: keyof typeof RoleType, 
    navigate: NavigateFunction, 
    id: string,
    currentPath?: string
) => {
    const orgId = SessionService.getItem(StorageKey.organizationId)
    
    switch (role) {
        case RoleType.USER:
            // If already on dashboard, scroll to top
            if (currentPath === "/dashboard") {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                navigate("/dashboard")
                window.scrollTo(0, 0)
            }
            break
        case RoleType.ORGANIZATION:
            const targetPath = `/organization-dashboard/${orgId || id}`
            
            // If already on organization dashboard, scroll to top
            if (currentPath === targetPath) {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                navigate(targetPath)
                window.scrollTo(0, 0)
            }
            break
        default:
            break
    }
}
